import React from "react";
import { Star } from "lucide-react";

export default function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <section className="relative py-10 border-y border-amber-900/30 bg-stone-950/40 backdrop-blur-sm overflow-hidden" data-testid="marquee-section">
      <div className="marquee-track">
        {doubled.map((text, i) => (
          <div key={i} className="flex items-center gap-6 px-8 shrink-0">
            <Star size={16} className="text-amber-600" />
            <span className="font-serif text-2xl md:text-3xl text-stone-100 whitespace-nowrap">
              {text}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
